










































































import { Component, Vue, Watch } from "vue-property-decorator";
import { DeleteResultModel, TagFilter, TagViewModel } from "@/services/api/nswag/stapiclient_generated";
import { stCustomerApi, stProjectTaskApi, stTagApi } from "@/services/st-api";
import StInput2 from "@/components/basic/StInput2.vue";
import StSearch from "@/components/basic/StSearch.vue";
import { orderBy } from "lodash";
import { DialogResponse } from "vue-tailwind/dist/components/TDialog";
import { notifySuccess } from "@/utlitities/notifications";

Component.registerHooks(["beforeRouteUpdate"]);

@Component({
  components: {
    StSearch,
    StInput2
  }
})
export default class Tags extends Vue {
  items: TagViewModel[] = [];
  search: string = "";
  delLoading: boolean = false;
  showArchived: boolean = false;
  archivedLoadingId = 0;

  loading = false;
  delayLoading = false;

  async mounted() {
    try {
      this.loading = true;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (to.name == "Tags") {
      try {
        this.delayLoading = true;
        await this.loadData();
      } finally {
        this.delayLoading = false;
      }
    }
  }

  @Watch("showArchived")
  async changeShowArchived() {
    this.loading = true;
    await this.loadData();
    this.loading = false;
  }

  async toggleArchive(id: number) {
    try {
      this.archivedLoadingId = id;
      const item = await stTagApi.get(id);
      item.isArchived = !item.isArchived;
      await stTagApi.put(id, item);
      await this.loadData();

      if (item.isArchived) {
        notifySuccess("Erfolgreich archiviert");
      } else {
        notifySuccess("Erfolgreich aktiviert");
      }
    } finally {
      this.archivedLoadingId = 0;
    }
  }

  get filteredTags() {
    return orderBy(
      this.items.filter((_) => _.name?.toLowerCase().indexOf(this.search.toLowerCase()) != -1),
      "name"
    );
  }

  editTag(id: number) {
    this.$router.push({ name: "EditTag", params: { id: id.toString() } });
  }

  async loadData() {
    const filter: TagFilter = TagFilter.fromJS({ isArchived: this.showArchived });
    this.items = await stTagApi.getList(filter);
  }

  async tagDelete(id: number) {
    try {
      this.delLoading = true;
      const result = await stTagApi.delete(id, false);
      if (result.confirmationNeeded) {
        const res: DialogResponse = await this.$dialog.confirm({
          title: this.$t("Bestätigung").toString(),
          text: result.message,
          variant: "danger",
          okButtonText: this.$t("Löschen").toString(),
          cancelButtonText: this.$t("Abbrechen").toString()
        });
        if (res.isOk) {
          await stTagApi.delete(id, true);
          await this.loadData();
          notifySuccess("Erfolgreich gelöscht");
        }
      } else {
        await this.loadData();
        notifySuccess("Erfolgreich gelöscht");
      }
    } finally {
      this.delLoading = false;
    }
  }
}
